var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-card", attrs: { id: "deviceSchedulesCard" } },
    [
      _c(
        "div",
        {
          staticClass: "clearfix",
          attrs: { slot: "header", id: "deviceScheduleHeaderContainer" },
          slot: "header",
        },
        [
          _c("span", { staticClass: "header-item" }, [
            _vm._v(_vm._s(_vm.$t("device.schedules"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-link__container" },
            [
              _c(
                "TextLink",
                {
                  on: {
                    click: function ($event) {
                      return _vm.showHelp()
                    },
                  },
                },
                [_vm._v("\n        Need help adding a schedule?\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("schedules-tabs", {
        attrs: { slot: "default", "device-name": _vm.deviceName },
        slot: "default",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }